import type { MilestoneId } from './wizard';

export const MILESTONES = {
  // Progress milestones
  CATEGORY_SELECTED: 'category_selected',
  PATIENT_INFO_COLLECTED: 'patient_info_collected',
  INSURANCE_DETERMINED: 'insurance_determined',
  PROFILE_CREATED: 'profile_created',
  PRODUCTS_SELECTED: 'products_selected',
  APPOINTMENT_RESERVED: 'appointment_reserved',
  PHONE_VERIFIED: 'phone_verified',

  // Exit milestones
  ORDER_COMPLETED: 'order_completed',
  WAITLISTED: 'waitlisted',
  REACH_OUT_PENDING: 'reach_out_pending',
} as const;

export const EXIT_MILESTONE_IDS: ReadonlySet<MilestoneId> = new Set([
  MILESTONES.ORDER_COMPLETED,
  MILESTONES.WAITLISTED,
  MILESTONES.REACH_OUT_PENDING,
]);
